import React from "react";
import Alert from "@mui/material/Alert";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import { describeApiError } from "../api/request";

export default function SleeveLabelPrinting({ albumId, printing }) {
  const titleId = React.useId();
  return (
    <>
      <Dialog
        open={printing.open}
        onClose={printing.close}
        aria-labelledby={titleId}
        fullWidth
        maxWidth="md"
      >
        <DialogTitle id={titleId}>Sleeve label preview</DialogTitle>
        <DialogContent>
          <p>Label printing optimized for 3x2 thermal labels</p>
          {printing.error && (
            <Alert severity="error">{describeApiError(printing.error)}</Alert>
          )}
          {printing.job?.status === "failed" && (
            <Alert severity="error">{printing.job.error}</Alert>
          )}
          {printing.job?.warnings.map((warning) => (
            <Alert key={warning} severity="warning">
              {warning}
            </Alert>
          ))}
          {printing.pdfUrl && (
            <>
              <object
                data={printing.pdfUrl}
                type="application/pdf"
                aria-label="Sleeve label PDF preview"
                style={{ width: "100%", height: "55vh" }}
              >
                <p>
                  Inline preview is unavailable in this browser. Open the PDF to
                  preview and print it.
                </p>
              </object>
            </>
          )}
        </DialogContent>
        <DialogActions sx={{ flexWrap: "wrap", gap: 1 }}>
          <Button onClick={printing.close}>Close</Button>
          {printing.error && (
            <Button onClick={printing.retry}>Retry request</Button>
          )}
          {!printing.pending && (
            <Button onClick={printing.start}>
              Generate using current data
            </Button>
          )}
          {printing.pdfUrl && (
            <>
              <Button
                component="a"
                href={printing.pdfUrl}
                download={`sleeve-${albumId}.pdf`}
              >
                Download PDF
              </Button>
              <Button
                component="a"
                href={printing.pdfUrl}
                target="_blank"
                rel="noopener noreferrer"
                variant="contained"
              >
                Open / Print PDF
              </Button>
            </>
          )}
        </DialogActions>
      </Dialog>
    </>
  );
}
